import { APIAnomalyUser } from "../../../types/APIAnomaly";
import {
  APIMonitorResolvedAnomalyAlert,
  APIMonitorUnresolvedAnomalyAlert,
  APIMonitorUnresolvedAnomalyAssignment,
} from "../../../types/APIMonitoringEnrollment";

export type SelectionAction =
  | "assign"
  | "export"
  | "delete"
  | "edit"
  | "pause"
  | "resume";

export type TableColumn =
  | "assigned_to"
  | "domain"
  | "external_ref_id"
  | "id"
  | "status"
  | "last_alerted"
  | "monitor_types"
  | "next_run";

export type TableOrderBy =
  | "created_at"
  | "-created_at"
  | "alerts"
  | "-alerts"
  | "assigned_to"
  | "-assigned_to"
  | "domain"
  | "-domain"
  | "external_ref_id"
  | "-external_ref_id"
  | "last_alerted"
  | "-last_alerted"
  | "monitor_types"
  | "-monitor_types"
  | "next_run"
  | "-next_run"
  | "status"
  | "-status";

export enum TableStatus {
  ALERT = "Alert",
  ALERT_AND_PENDING = "Alerts/Processing",
  ALL_CLEAR = "No Alerts",
  PENDING = "Processing",
}

export enum TableMonitorType {
  CONNECTED_ENTITIES = "Connected Entities",
  BUSINESS_CLOSURE = "Business Closure",
  WEBSITE_CONTENT = "Website Content",
  SENTIMENT_ANALYSIS = "Sentiment Analysis",
  PEOPLE = "Executive Changes",
  BUSINESS_PROFILE = "Business Profile",
}

export type TableFilterBy =
  | { column: "alerts"; operator: "in"; value: string[] }
  | { column: "assigned_to"; operator: "in"; value: string[] }
  | { column: "domain"; operator: "in"; value: string[] }
  | { column: "external_ref_id"; operator: "in"; value: string[] }
  | { column: "status"; operator: "in"; value: TableStatus[] }
  | { column: "last_alerted"; operator: "gte"; value: Date }
  | { column: "last_alerted"; operator: "gt"; value: Date }
  | { column: "last_alerted"; operator: "lte"; value: Date }
  | { column: "last_alerted"; operator: "lt"; value: Date }
  | { column: "monitor_types"; operator: "in"; value: TableMonitorType[] }
  | { column: "next_run"; operator: "gte"; value: Date }
  | { column: "next_run"; operator: "gt"; value: Date }
  | { column: "next_run"; operator: "lte"; value: Date }
  | { column: "next_run"; operator: "lt"; value: Date };

export interface TableRow {
  alerts: string[];
  _resolved_alerts: APIMonitorResolvedAnomalyAlert[];
  _unresolved_alerts: APIMonitorUnresolvedAnomalyAlert[];
  assigned_to: APIMonitorUnresolvedAnomalyAssignment[] | null | undefined;
  domain: string | undefined;
  external_ref_id: string | null | undefined;
  id: UUID;
  last_alerted?: ISODateTime | null | undefined;
  monitor_types: TableMonitorType[];
  next_run?: ISODateTime | null | undefined;
  status: TableStatus | null | undefined;
}

export enum ExportStatus {
  OPEN = "Open",
  ASSIGNED = "Assigned",
  RESOLVED = "Resolved",
}
export interface ExportRow {
  // TODO: re-factor this to be integrated with the main types
  alerts: string[];
  assignee: APIAnomalyUser | null | undefined;
  date: ISODateTime;
  domain: string | undefined;
  external_ref_id: string | null | undefined;
  id: UUID;
  status: ExportStatus | null | undefined;

  // only used for export
  messages: string[];
  acknowledged_at: ISODateTime | null | undefined;
  acknowledged_by: string | null | undefined; // email
  acknowledged_reason: string | null | undefined;
  acknowledged_notes: string | null | undefined;
}
